import { FjdIcon, FjdModal, FjdStack } from "@efast/fjd-react-components";
import QrReader from "react-qr-reader";
import txt from "./../../content.json";
import "./QRScanModal.css";

export interface QRScanModalProps {
  onError: (err: any) => void;
  onScan: (data: string | null) => void;
  onClose: (event: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>) => void;
  open?: boolean;
}

function QRScanModal({ onError, onScan, onClose, open }: QRScanModalProps) {
  return (
    <FjdModal
      closeOnBackdropClick={true}
      closable={true}
      // width="fullscreen"
      onClose={onClose}
      open={open}
      heading={txt.qrScanModal.title}
      appElement={document.getElementById("root") as HTMLElement}
      testId={"fjd-modal"}
    >
      {open && <QrReader delay={300} onError={onError} onScan={onScan} style={{ width: "100%" }} />}
      <FjdStack className="qr-scan-modal__info">
        <FjdIcon appearance="info" glyph="information-outline" size="xxl"></FjdIcon>
        {txt.qrScanModal.description}
      </FjdStack>
    </FjdModal>
  );
}

export default QRScanModal;
